<mat-list [ngClass]="{ 'heating': heating, 'cooling': cooling }" class="list">

    <dl-card-nest-slider-wrapper *ngIf="!rowMode"
                                 [heating]="heating"
                                 [cooling]="cooling"
                                 [displayInfo]="displayInfo"
                                 [displayInfoForEdit]="displayInfoForEdit"
                                 [isEditMode]="isEditMode"
                                 [deviceInputForm]="form"
                                 [setDeviceInfo]="setDeviceInfo"
                                 [deviceInfo]="dashboardEditModel">
    </dl-card-nest-slider-wrapper>

    <div *ngFor="let item of currentDisplayInfoViewModel; let index = index">
        <mat-card
            #displayInfo
            *ngIf="rowMode; else notRowModeBlock"
            (click)="indicateCardClicked(index, item)"
            class="row-item row-item-indented"
            [ngClass]="{ 'heating': heating, 'cooling': cooling }"
        >
            <dl-card-list-item *ngIf="!isEditMode" [item]="item" [heating]="heating" [cooling]="cooling"></dl-card-list-item>
        </mat-card>
        <ng-template #notRowModeBlock>
            <ng-container *ngIf="!shouldItemBeHidden(item)">
                <dl-card-list-item [item]="item" [heating]="heating" [cooling]="cooling"
                                   [hideValue]="isEditMode"></dl-card-list-item>
            </ng-container>
        </ng-template>

        <mat-list-item *ngIf="isEditMode && item.isEnabled && getDeviceInput(item) && !shouldItemBeHidden(item)"
                       class="edit-divider">
            <div mat-list-icon class="fake-icon-spacer">
            </div>
            <dl-device-input
                [ngClass]="getDeviceInput(item).$inputType"
                [deviceInfo]="dashboardEditModel"
                [deviceInput]="getDeviceInput(item)"
                [deviceInputForm]="form"
                [setDeviceInfo]="setDeviceInfo"
            >
            </dl-device-input>
        </mat-list-item>
    </div>
    <mat-list-item *ngIf="isMoreLessButtonNeeded">
        <div style="flex: 1 1 auto;"></div>
        <button (click)="showMoreItems()" *ngIf="moreButtonVisible()" aria-label="SHOW MORE" mat-button
                class="moreLessBtn">
            SHOW MORE ({{hiddenCount}})
            <mat-icon>expand_more</mat-icon>
        </button>
        <button (click)="showLessItems()" *ngIf="lessButtonVisible()" aria-label="SHOW LESS" mat-button
                class="moreLessBtn">
            SHOW LESS
            <mat-icon>expand_less</mat-icon>
        </button>
    </mat-list-item>
    <mat-card
            *ngIf="rowMode && selectedCard !== undefined"
            [@fillScreenAnimation]="{value: 'for', params: { top: animationScrollTop } }"
            (@fillScreenAnimation.done)="fireClickEvent(selectedCard)"
            [ngStyle]="{
            top: startAnimationTop,
            height: startAnimationHeight,
            width: startAnimationWidth,
            position: 'absolute',
            'z-index': 500
        }"
            class="row-item"
            [ngClass]="{ 'heating': heating, 'cooling': cooling }"
    >
        <dl-card-list-item *ngIf="!isEditMode" [item]="selectedCard" [heating]="heating"
                           [cooling]="cooling"></dl-card-list-item>
    </mat-card>
</mat-list>
